<template>
  <div
    v-if="!hide"
    class="input-field-npv"
    :style="{
      width: inputFieldSize + '%',
      paddingBottom: inputType === 'group' ? 0 : '4px',
    }"
    :data-variable-name="variableName"
    :data-list-name="selectOptions"
  >
    <template v-if="inputType === 'group'">
      <label style="margin-bottom: 10px" class="group-label">
        {{ label }}
      </label>

      <v-divider />
    </template>

    <label
      v-else-if="label !== ''"
      class="form-label-div labelInputNPV"
      style="margin-bottom: 6px"
      :class="{ disabled: disabled }"
    >
      {{ label }} <span v-if="required">*</span
      ><span v-if="badLabel" class="errorLabel">Limit is: {{ limit }} </span>
    </label>
    <div style="display: flex; flex-direction: row; ">
      <InputTypeTextNPV
        v-if="inputType === 'text'"
        :value="value"
        :disabled="
          disabled || (labelIsLocked && variableName.includes('_label'))
        "
        :placeholder="placeholder"
        :automatic-label="automaticLabel"
        :var-name="variableName"
        :restrictSpecialCharacters="restrictSpecialCharacters"
        :required-fail="requiredFail"
        @check-alphanumeric="checkAlphanumeric"
        @updateValue="updateValue($event)"
        @generateLabel="$emit('generateLabel')"
      />

      <InputTypeNumberNPV
        v-else-if="
          inputType === 'number' ||
          inputType === 'int' ||
          inputType === 'integer' ||
          inputType === 'float' ||
          inputType === 'int_pos' ||
          inputType === 'float_pos' ||
          inputType === 'number_pos'
        "
        :value="value"
        :disabled="disabled"
        :placeholder="placeholder"
        :min="minValue"
        :max="max"
        :step="step"
        :onkeyDown="onKeyDown"
        :input-type="inputType"
        :var-name="variableName"
        @updateValue="updateValue($event)"
      />

      <InputTypeEmailNPV
        v-else-if="inputType === 'email'"
        :value="value"
        :disabled="disabled"
        :placeholder="placeholder"
        :var-name="variableName"
        :required-fail="requiredFail"
        @updateValue="updateValue($event)"
      />

      <InputTypeTextAreaNPV
        v-else-if="inputType === 'textarea'"
        :value="value"
        :disabled="disabled"
        :required-fail="requiredFail"
        @updateValue="updateValue($event)"
      />

      <InputTypeTreeSelectNPV
        v-else-if="
          inputType === 'select' ||
          inputType === 'multi-select' ||
          inputType === 'multiselect'
        "
        :value="value"
        :select-options="selectOptions"
        :multiple="inputType === 'multi-select' || inputType === 'multiselect'"
        :placeholder="selectPlaceholder"
        :disabled="disabled"
        :clearable="clearable"
        :required-fail="requiredFail"
        @updateValue="updateValue($event)"
      />

      <InputTypeTreeSelectUserNPV
        v-else-if="inputType === 'user'"
        :value="value"
        :placeholder="selectPlaceholder"
        :disabled="disabled"
        :clearable="clearable"
        :required-fail="requiredFail"
        @updateValue="updateValue($event)"
      />

      <InputTypeRadioNPV
        v-else-if="inputType === 'radio'"
        :value="value"
        :disabled="disabled"
        :radio-in-column="radioInColumn"
        :radio-options="radioOptions"
        :required-fail="requiredFail"
        @updateValue="updateValue($event)"
      />

      <InputTypeUrlNPV
        v-else-if="inputType === 'url'"
        :value="value"
        :disabled="disabled"
        :placeholder="placeholder"
        :required-fail="requiredFail"
        @updateValue="updateValue($event)"
      />

      <InputTypeDateNPV
        v-else-if="inputType === 'date'"
        :value="value"
        :disabled="disabled"
        :required="required"
        :required-fail="requiredFail"
        @updateValue="updateValue($event)"
      />

      <InputTypeDateTimeNPV
        v-else-if="inputType === 'datetime'"
        type="datetime-local"
        :value="value"
        :disabled="disabled"
        :min="min"
        :max="max"
        :step="step"
        :required="required"
        :required-fail="requiredFail"
        @updateValue="updateValue($event)"
        style="max-width: 100%; width: 100%"
      />

      <InputTypeCheckBoxNPV
        v-else-if="inputType === 'checkbox'"
        :value="value"
        :var-name="variableName"
        :object-data="objectData"
        :checkbox-options="checkboxOptions"
        :disabled="disabled"
        :required-fail="requiredFail"
        @change="updateCheckboxValue($event)"
      />

      <InputTypePhotoNPV
        v-else-if="inputType === 'photo'"
        :disabled="disabled"
        :value="value"
        :label="label"
        :var-name="variableName"
        @change="updateValue($event)"
        @removePhoto="$emit('removePhoto', $event)"
      />

      <div
        v-else-if="inputType === 'other'"
        class="input-container"
        :class="{ 'required-fail': requiredFail }"
        :disabled="disabled"
      >
        <slot />
      </div>

      <v-icon
        v-if="fieldIsLabel"
        @click="$emit('toggle-label-lock')"
        :disabled="userCanUnlockLabel"
        style="color: var(--v-accent-base)"
        >{{ labelIsLocked ? "mdi-lock" : "mdi-lock-open" }}</v-icon
      >
    </div>
  </div>
</template>

<script>
import InputTypeTextNPV from "./InputTypesNPV/InputTypeTextNPV";
import InputTypeNumberNPV from "./InputTypesNPV/InputTypeNumberNPV";
import InputTypeEmailNPV from "./InputTypesNPV/InputTypeEmailNPV";
import InputTypeTextAreaNPV from "./InputTypesNPV/InputTypeTextAreaNPV";
import InputTypeDateTimeNPV from "./InputTypesNPV/InputTypeDateTimeNPV";
import InputTypeUrlNPV from "./InputTypesNPV/InputTypeUrlNPV";
import InputTypeDateNPV from "./InputTypesNPV/InputTypeDateNPV";
import InputTypeRadioNPV from "./InputTypesNPV/InputTypeRadioNPV";
import InputTypeTreeSelectNPV from "./InputTypesNPV/InputTypeTreeSelectNPV";
import InputTypeTreeSelectUserNPV from "./InputTypesNPV/InputTypeTreeSelectUserNPV";
import InputTypeCheckBoxNPV from "./InputTypesNPV/InputTypeCheckBoxNPV";
import InputTypePhotoNPV from "./InputTypesNPV/InputTypePhotoNPV";

export default {
  name: "InputFieldNPV",

  components: {
    InputTypePhotoNPV,
    InputTypeCheckBoxNPV,
    InputTypeTreeSelectUserNPV,
    InputTypeTreeSelectNPV,
    InputTypeRadioNPV,
    InputTypeDateNPV,
    InputTypeUrlNPV,
    InputTypeDateTimeNPV,
    InputTypeTextAreaNPV,
    InputTypeEmailNPV,
    InputTypeNumberNPV,
    InputTypeTextNPV,
  },

  props: {
    /**
     * Name of the input field
     */
    label: {
      type: String,
      required: true,
    },
    limit: {
      type: String,
    },
    variableName: {
      type: String,
    },
    /**
     * Type of input field.
     */
    inputType: {
      type: String,
      required: true,
    },
    badLabel: {
      type: Boolean,
    },
    /**
     * Size of the input field.
     */
    size: {
      type: String,
      required: true,
    },
    /**
     * Name of the variable to use.
     */
    value: {
      required: true,
    },
    /**
     * Defines if input field is required.
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * Defines if the required fields are filled or not.
     */
    requiredFilled: {
      type: Boolean,
      default: false,
    },
    /**
     * Defines if input field is disabled.
     */
    fieldDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Defines if tab is disabled.
     */
    tabDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Defines if form is disabled.
     */
    formDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Defines if the input field is to be hidden.
     */
    hide: {
      type: Boolean,
      default: false,
    },
    /**
     * Name of options list to use in the Select field.
     */
    selectOptions: {
      type: String,
      required: false,
    },

    /**
     * List of options to show in the Radio field.
     */
    radioOptions: {
      type: Array,
      required: false,
    },

    radioInColumn: {
      type: Boolean,
      default: false,
    },

    labelIsLocked: {
      type: Boolean,
    },

    userCanUnlockLabel: {
      type: Boolean,
    },
    /**
     * Determines if the label can be created automatically
     */
    automaticLabel: {
      type: Boolean,
    },
    //if used user cant type in '-' (when using min user cant use negative numbers using the input arrows but can put it in manually)
    onKeyDown: {
      type: String,
      default: null,
    },

    step: {
      type: Number | String,
    },

    min: {
      type: Number | String,
    },

    max: {
      type: Number | String,
    },
    maxLength: {
      type: String,
    },
    placeholder: {
      type: String,
    },

    clearable: {
      type: Boolean,
      default: true,
    },

    /**
     * List of options to show in the Checkbox field.
     */
    checkboxOptions: {
      type: Array,
      required: false,
    },

    objectData: {
      type: Object,
    },
    restrictSpecialCharacters: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    /**
     * Defines the width of the input field.
     * @returns {number} the percentage value of the tab width used for the field.
     */
    inputFieldSize() {
      if (!isNaN(this.size)) {
        return parseInt(this.size);
      } else {
        switch (this.size) {
          case "xSmall":
            return 100 / 6;
          case "small":
            return 100 / 3;
          case "medium":
            return (100 / 3) * 2;
          case "large":
            return 100;
          default:
            return 100 / 3;
        }
      }
    },

    disabled() {
      return this.fieldDisabled || this.tabDisabled || this.formDisabled;
    },
    fieldIsLabel() {
      if (this.variableName) {
        return this.variableName.includes("_label");
      }
    },

    selectPlaceholder() {
      let placeholder = this.$i18n.t("SelectOption");
      if (this.disabled) {
        return "";
      } else if (this.placeholder) {
        placeholder = this.placeholder;
      }
      return placeholder;
    },

    requiredFail() {
      return (
        !this.hide &&
        this.required &&
        !this.requiredFilled &&
        (this.value === undefined || this.value === null || this.value === "")
      );
    },
    minValue() {
      if (
        this.inputType === "int_pos" ||
        this.inputType === "float_pos" ||
        this.inputType === "number_pos"
      ) {
        return 0;
      } else {
        return this.min;
      }
    },
  },

  methods: {
    updateValue(e) {
      this.$emit("input", e);
    },
    isNumberKey(evt) {
      if (this.min === 0) {
        var charCode = evt.which ? evt.which : event.keyCode;
        return !(charCode > 31 && (charCode < 48 || charCode > 57));
      }
    },

    updateCheckboxValue(e) {
      this.$emit("updateCheckboxValue", e);
    },
    checkAlphanumeric(e) {
      this.$emit("check-alphanumeric", e);
    },
  },
};
</script>

<style scoped>
.labelInputNPV {
  color: #767676;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.group-label {
  text-transform: uppercase;
  margin-top: 4px;
  margin-bottom: 4px !important;
}
.errorLabel {
  color: red !important;
}

.input-field-npv {
  height: 32px;
  background-color: transparent;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/InputFieldsNPV.vue